import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { SuperadminComponent } from '../superadmin/superadmin.component';
import { AdminInvoiceReceiptComponent } from './admin-invoice-receipt/admin-invoice-receipt.component';
import { AdminInvoiceComponent } from './admin-invoice/admin-invoice.component';
import { AdminSaleOrderComponent } from './admin-sale-order/admin-sale-order.component';
import { AdminServiceRenewalComponent } from './admin-service-renewal/admin-service-renewal.component';
import { InvoicePrintComponent } from './invoice-print/invoice-print.component';
import { InvoiceReceiptComponent } from './invoice-receipt/invoice-receipt.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { PayComponent } from './pay/pay.component';
import { PayoutHistoryComponent } from './payout-history/payout-history.component';
import { PayoutPayComponent } from './payout-pay/payout-pay.component';
import { SaleOrderComponent } from './sale-order/sale-order.component';
import { SaleSubscriptionComponent } from './sale-subscription/sale-subscription.component';
import { ServiceRenewalComponent } from './service-renewal/service-renewal.component';
import { SuccessComponent } from './success/success.component';


const routes: Routes = [
  { 
    path: '', 
    component: AdminComponent,
    children: [
      { path: 'sale-order', component: SaleOrderComponent, pathMatch: 'full' },
      { path: 'invoice', component: InvoiceComponent, pathMatch: 'full' },
      { path: 'invoice-receipt', component: InvoiceReceiptComponent, pathMatch: 'full' },
      { path: 'service-renewal', component: ServiceRenewalComponent, pathMatch: 'full' },
      { path: 'sale-subscription', component: SaleSubscriptionComponent, pathMatch: 'full' },
      { path: 'pay', component:PayComponent, pathMatch: 'full'},
      { path: 'success', component:SuccessComponent, pathMatch: 'full'},
      
    ]
},
{
  path: '', children:[
    { path: 'printinvoice', component:InvoicePrintComponent, pathMatch: 'full'},

  ]
},
{ 
  path: '', 
  component: SuperadminComponent,
  children: [
    { path: 'superadmin/payout-pay', component: PayoutPayComponent, pathMatch: 'full' },
    { path: 'superadmin/admin-sale-order', component: AdminSaleOrderComponent, pathMatch: 'full' },
    { path: 'superadmin/admin-invoice', component: AdminInvoiceComponent, pathMatch: 'full' },
    { path: 'superadmin/payout-history', component: PayoutHistoryComponent, pathMatch: 'full' },
    { path: 'superadmin/admin-invoice-receipt', component: AdminInvoiceReceiptComponent, pathMatch: 'full' },
    { path: 'superadmin/admin-service-renewal', component: AdminServiceRenewalComponent, pathMatch: 'full' }
   
  ]
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalRoutingModule { }
